import { render, staticRenderFns } from "./LibrariesDatatable.vue?vue&type=template&id=a5bbc754"
import script from "./LibrariesDatatable.vue?vue&type=script&lang=js"
export * from "./LibrariesDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports